import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-color-grp-lang',
  templateUrl: './color-grp-lang.component.html',
  styleUrls: ['./color-grp-lang.component.css']
})
export class ColorGrpLangComponent implements OnInit {
    colorGrpId;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.colorGrpId = this.stateService.getStateParams()['colorgrp_id'];
    }

    private async loadLanguages() {
        if (!!this.colorGrpId) {
            this.inputListLanguages = await this.datatask.Post(1210, { colorgrp_id: this.colorGrpId });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(1211, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    colorgrp_id: string;
    colorgrp_lang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}
